// extracted by mini-css-extract-plugin
module.exports = {"header":"cb_cc","heading":"cb_ce"};